import 'twin.macro';
import {
  BellIcon,
  CalendarIcon,
  ExclamationTriangleIcon,
  GiftIcon,
  HeartIcon,
  MegaphoneIcon,
  SparklesIcon,
} from '@heroicons/react/24/outline';
import { GlobalMessageIcon } from 'types/cms';

export function GlobalMessageIconComponent({
  icon,
}: {
  icon: GlobalMessageIcon;
}) {
  if (icon === 'heroicons:exclamation-triangle') {
    return <ExclamationTriangleIcon tw="h-5 w-5 inline-block" />;
  }
  if (icon === 'heroicons:gift') {
    return <GiftIcon tw="h-5 w-5 inline-block" />;
  }
  if (icon === 'heroicons:bell') {
    return <BellIcon tw="h-5 w-5 inline-block" />;
  }
  if (icon === 'heroicons:calendar') {
    return <CalendarIcon tw="h-5 w-5 inline-block" />;
  }
  if (icon === 'heroicons:megaphone') {
    return <MegaphoneIcon tw="h-5 w-5 inline-block" />;
  }
  if (icon === 'heroicons:sparkles') {
    return <SparklesIcon tw="h-5 w-5 inline-block" />;
  }
  if (icon === 'heroicons:heart') {
    return <HeartIcon tw="h-5 w-5 inline-block" />;
  }
  return null;
}
